// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3xQ6V","footer":"ModalError_footer__3-2DL"};